import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoGameDeckWidget" */ './CasinoGameDeckWidget'),
  modules: ['./CasinoGameDeckWidget'],
  loading: () => <div />
});

export default LoadableWidget;
